import { Grid, Typography } from '@mui/material';
import { includes } from 'lodash';
import { BooleanField, FunctionField, Labeled, SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import { RetirementAccountTypeDto } from 'src/dtos';
import { AccountStatusChip } from 'src/lib';
import { Account } from 'src/models';

import { SyncAccountListStatusButton } from '../SyncAccountListStatusButton';

export const AccountDetails = () => {
  const record = useRecordContext<Account>();
  const { id } = record;

  if (!record) {
    return null;
  }

  return (
    <Grid container direction='row'>
      <Grid item md={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Account Information</Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <Labeled>
            <TextField source='accountId' label='Account Id' />
          </Labeled>
        </SimpleShowLayout>
        <SimpleShowLayout>
          <Labeled>
            <TextField source='accountNumber' label='Account Number' />
          </Labeled>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <Labeled>
            <TextField source='type.label' label='Account Type' />
          </Labeled>
        </SimpleShowLayout>
        {record.type.isJoint && (
          <SimpleShowLayout>
            <Labeled>
              <TextField source='jointAccountType.label' label='Joint Account Type' />
            </Labeled>
          </SimpleShowLayout>
        )}
        {record.type.isRetirement && (
          <SimpleShowLayout>
            <Labeled>
              <TextField source='retirementAccountType.label' label='Retirement Account Type' />
            </Labeled>
          </SimpleShowLayout>
        )}
        {record.type.isEntity && (
          <SimpleShowLayout>
            <Labeled>
              <TextField source='entityAccountType.label' label='Entity Account Type' />
            </Labeled>
          </SimpleShowLayout>
        )}
      </Grid>
      {record.type.isJoint && record.jointAccountType?.isCommunity && (
        <Grid item md={6}>
          <SimpleShowLayout>
            <Labeled>
              <TextField source='jointCommunityPropertyState.label' label='Community Property State' />
            </Labeled>
          </SimpleShowLayout>
        </Grid>
      )}
      {record.type.isRetirement && record.retirementAccountType?.isSimple && (
        <Grid item md={6}>
          <SimpleShowLayout>
            <Labeled>
              <TextField source='simpleIraPlanName' label='Simple IRA Plan Name' />
            </Labeled>
          </SimpleShowLayout>
        </Grid>
      )}
      {record.type.isRetirement &&
        includes(
          [RetirementAccountTypeDto.Beneficiary, RetirementAccountTypeDto.RothBeneficiary],
          record.retirementAccountType?.value,
        ) && (
          <Grid item md={6}>
            <SimpleShowLayout>
              <Labeled>
                <TextField source='beneficiaryIraDecedentName' label='Beneficiary Ira Decedent Name' />
              </Labeled>
            </SimpleShowLayout>
          </Grid>
        )}
      <Grid item md={6}>
        <SimpleShowLayout>
          <Labeled>
            <BooleanField source='isAccredited' label='Is Accredited' />
          </Labeled>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <Labeled>
            <FunctionField
              label='Account Status (My IPO Server)'
              render={(account: Account) => {
                return (
                  <>
                    {account?.status && <AccountStatusChip value={account.status} />}
                    {Boolean(account?.accountId) && <SyncAccountListStatusButton ids={[id]} />}
                  </>
                );
              }}
            />
          </Labeled>
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
